export const ANNOUNCEMENT_QUERY_PARAMETER = 'announcement';

export function buildAnnouncementElementId(announcementId: string): string {
  return 'announcement-' + announcementId;
}
